export default {"src":"/_next/static/image/public/images/freeGift.9fdeb5464fc7688dd5525b5884b6577f.svg","height":17,"width":20};